/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IFindStoreWorldwide containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum searchRadiusUnit {
    miles = 'miles',
    kilometers = 'kilometers'
}

export interface IFindStoreWorldwideConfig extends Msdyn365.IModuleConfig {
    heading?: string;
    termsOfServiceLink?: ITermsOfServiceLinkData;
    searchRadiusUnit?: searchRadiusUnit;
    displayIncludeRetailersButton?: boolean;
    displayStorePageLinks?: boolean;
    storePageLinksContries?: string[];
    defaultIncludeRetailers?: boolean;
    autoSuggestionEnabled?: boolean;
    autoSuggestOptions?: IAutoSuggestOptionsData;
    className?: string;
    clientRender?: boolean;
    renderLinkToStorePage?: boolean;
}

export interface IFindStoreWorldwideResources {
    includeRetailersButtonLabel: string;
    storeLabelVenchi: string;
    storeLabelRetailer: string;
    goToStoreWebPage: string;
    searchPlaceholderText: string;
    searchButtonAriaLabel: string;
    searchInputAriaLabel: string;
    emptyLocationsText: string;
    timeText: string;
    milesShortText: string;
    kilometersShortText: string;
    storeHoursClosedText: string;
    storeHoursMondayText: string;
    storeHoursTuesdayText: string;
    storeHoursWednesdayText: string;
    storeHoursThursdayText: string;
    storeHoursFridayText: string;
    storeHoursSaturdayText: string;
    storeHoursSundayText: string;
    storeHoursMondayFullText: string;
    storeHoursTuesdayFullText: string;
    storeHoursWednesdayFullText: string;
    storeHoursThursdayFullText: string;
    storeHoursFridayFullText: string;
    storeHoursSaturdayFullText: string;
    storeHoursSundayFullText: string;
    storeAllCountMessage: string;
    storeAndRetailersAllCountMessage: string;
    storeLocatorHeaderText: string;
    viewMapText: string;
    viewListText: string;
}

export interface ITermsOfServiceLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAutoSuggestOptionsData {
    maxResults?: number;
}

export interface IFindStoreWorldwideProps<T> extends Msdyn365.IModule<T> {
    resources: IFindStoreWorldwideResources;
    config: IFindStoreWorldwideConfig;
    slots: {
        maps: React.ReactNode[];
    };
}
